import { brandInfo } from '@/mocks/home';
import { clamp, TRANSITION, COLORS } from './progress';

interface HeroSceneProps {
  progress: number;
  navigateTo: (target: number) => void;
  brandAnchor: number;
  booksAnchor: number;
}

export default function HeroScene({
  progress,
  navigateTo,
  brandAnchor,
  booksAnchor,
}: HeroSceneProps) {
  const p = clamp(progress, 0, 1);
  const slideX = Math.pow(p, 2) * 120;
  const opacity = 1 - clamp(p * 1.7, 0, 1);

  return (
    <div
      className="absolute inset-0 z-20 flex items-center justify-center px-6 pt-20 md:pt-24 pb-10 pointer-events-none"
      style={{
        transform: `translateX(${slideX}vw)`,
        opacity,
        transition: TRANSITION,
        willChange: 'transform, opacity',
      }}
    >
      <div className="w-full max-w-3xl text-center">
        {/* 頂部裝飾列 */}
        <div className="flex items-center justify-center gap-3 mb-7">
          <span className="w-14 h-px bg-white/40" />
          <span className="font-manrope text-white/70 text-[10px] uppercase tracking-[0.4em]">
            StratDot · 策點文化
          </span>
          <span className="w-14 h-px bg-white/40" />
        </div>

        {/* Logo */}
        <div className="mb-7">
          <img
            src="https://storage.readdy-site.link/project_files/1f915489-d2bb-41ea-8578-6e8214ecd4ed/4d41668d-e4a8-4411-a337-02cb80057f7a_compressed_logo.webp"
            alt="策點文化 StratDot 官方網站"
            title="策點文化 StratDot"
            className="w-16 h-16 md:w-20 md:h-20 mx-auto rounded-lg"
          />
        </div>

        {/* 主標題 */}
        <h1 className="mb-5">
          <span
            className="block font-michroma text-white leading-[1.1] tracking-[0.04em]"
            style={{ fontSize: 'clamp(20px, 3vw, 40px)' }}
          >
            STRATDOT
          </span>
          <span
            className="block mt-3 font-semibold text-white leading-[1.15]"
            style={{ fontSize: 'clamp(32px, 5.5vw, 72px)', letterSpacing: '0.02em' }}
          >
            策點文化
          </span>
        </h1>

        {/* 標語 */}
        <p
          className="font-playfair italic text-white/90 mb-4"
          style={{ fontSize: 'clamp(16px, 2vw, 22px)' }}
        >
          {brandInfo.tagline}
        </p>

        {/* 描述 */}
        <p className="font-manrope text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto mb-10">
          {brandInfo.description}
        </p>

        {/* 按鈕 */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pointer-events-auto">
          <button
            onClick={() => navigateTo(booksAnchor)}
            className="px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300"
            style={{ backgroundColor: COLORS.cream, color: COLORS.ink }}
          >
            瀏覽出版書籍
          </button>
          <button
            onClick={() => navigateTo(brandAnchor)}
            className="px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300"
            style={{ backgroundColor: 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' }}
          >
            認識策點文化
          </button>
          <a
            href="https://catalog.sonbook.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 inline-flex items-center gap-2"
            style={{ backgroundColor: 'rgba(255,255,255,0.08)', color: '#fff', border: '1px solid rgba(255,255,255,0.18)' }}
          >
            查詢完整書目
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
        </div>
      </div>

      {/* 捲動提示 */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-3 font-manrope text-white/60 text-[10px] uppercase tracking-[0.3em]">
        <span>Scroll</span>
        <span className="w-10 h-px bg-white/50"></span>
      </div>
    </div>
  );
}